import React from "react";
var __jsx = React.createElement;
import stl from "./carDetailsSection.module.css";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
var SingleCarCC = function SingleCarCC(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: stl.CCContainer,
    "aria-label": props.title
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    src: props.icon,
    alt: "icon",
    width: 24,
    height: 24,
    loading: "lazy"
  }), /*#__PURE__*/React.createElement("label", null, props.title, ":"), /*#__PURE__*/React.createElement("strong", null, props.field), props.colorCode && /*#__PURE__*/React.createElement("div", {
    className: stl.colorBox,
    style: {
      backgroundColor: props.colorCode
    }
  }));
};
export default SingleCarCC;